import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { translate, LANGUAGES } from '../i18n/strings';

const LanguageContext = createContext(null);
const STORAGE_KEY = 'napho.lang';

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const saved = typeof localStorage !== 'undefined' && localStorage.getItem(STORAGE_KEY);
    if (saved && LANGUAGES.some((l) => l.code === saved)) return saved;
    const nav = (typeof navigator !== 'undefined' && navigator.language) || 'en';
    const base = nav.slice(0, 2);
    return LANGUAGES.some((l) => l.code === base) ? base : 'en';
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback((key) => translate(lang, key), [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, languages: LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
}
